<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">账号注销</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>
    <div class="main">
      <div class="warning-block">
        <div class="div1 ub ub-ac ub-pc">
          <img src="../assets/img/提醒.png" class="warning-img" />
          <label class="warning-txt">注销须知</label>
        </div>

        <div class="div2">
          <span class="txt">注销账号是不可恢复的操作，注销账号之后你将无法使用本账号。</span>
        </div>
      </div>

      <div class="notice-block">
        <label class="notice-txt">账号注销须知</label>
        <div>
          <label class="notice-txt2">
            注销账号是不可恢复的操作，注销账号之后你将无法使用本账号,也无法找回本账号及账号相关的任何信息包括:
            <br />① 你将无法登录，使用本账号
            <br />② 所有信息将被永久删除，你的好友无法再与你取得联系
            <br />③ 账号剩余金币、VIP权益、钱包余额、积分视为你自行放弃，充值部分不予退款
          </label>
        </div>
        <label class="notice-txt">注销前提</label>
        <div>
          <label class="notice-txt2">
            ① 账号处于安全状态
            <br />② 账号未被系统封禁
            <br />③ 近期15日内未收到投诉举报等风险
          </label>
        </div>
      </div>

      <div class="info-block">
        <label class="notice-txt">注销申请</label>
        <div class="ub ub-pc">
          <input placeholder="请输入微信号" v-model="wx" :readonly="state=='待审核' ? 'readonly' : false"/>
        </div>
        <div class="ub ub-pc">
          <input placeholder="请输入手机号"  v-model="tel" :readonly="state=='待审核' ? 'readonly' : false"/>
        </div>
        <div class="ub">
          <textarea placeholder="请输入注销原因" v-model="dtl" :readonly="state=='待审核' ? 'readonly' : false"></textarea>
        </div>
      </div>
      <div class="ub ub-ac" style="padding: 0 .6rem;" v-if="tip == ''">
        <div class="btn" @click="save()">申请</div>
      </div>
      <div class="state-tip">{{tip}}</div>
    </div>
    <alert ref="myConfirm"></alert>
  </div>
</template>

<script>
import * as tool from "../api/common";
import { mapMutations, mapActions } from "vuex";
import Alert from "../components/Alert.vue";

export default {
  components: {
    alert: Alert,
  },
  data() {
    return {
      wx: "",
      tel: "",
      dtl: "",
      tip: "",
      state:""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    save() {
      var uid = this.$store.state.uid;
      var wx = this.wx;
      var tel = this.tel;
      var dtl = this.dtl;
      if (wx == "") {
        this.$toast.center("微信号不能为空哦~");
        return false;
      }
      if (tel == "") {
        //会员提示
         this.$toast.center("手机号不能为空哦~");
        return false;
      }
      if (dtl == "") {
        //会员提示
        this.$toast.center("注销原因不能为空哦~");
        return false;
      }

      var data_send = {
        wx: wx,
        tel: tel,
        dtl: dtl,
      };
      var strsend = JSON.stringify(data_send);
      var self = this;
      this.post({
        url: "/App/Cancel_Save",
        data: { uid: uid, data: strsend },
        success: function (serve_data) {
          self.$toast.center("你的申请已提交，请等待平台审核。");

          self.tip = "你的申请已提交，请等待平台审核。请添加客服微信【LD987643210】，添加时备注【注销账号】";
        },
      });
    },

    init() {
      var uid = this.$store.state.uid;
      var self = this;
      this.get({
        url: "/App/Get_Cancel_Data/?uid=" + uid,
        success: function (data) {
          //console.log(JSON.stringify(data));
          if (data.state) {
            self.wx = data.wx;
            self.tel = data.tel;
            self.dtl = data.reason;
            self.state=data.state;
            var state = data.state;
            if (state == "待审核") {
              self.tip =
                "你的申请已提交，请等待平台审核。请添加客服微信【LD987643210】，添加时备注【注销账号】";
            }
            if (state == "失败") {
              self.tip = "审核失败，您的账号暂时不符合注销条件！";
            }
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding: 0 0.8rem;
  background-color: white;
}

.warning-block {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 3rem 0 3rem;
  flex-direction: column;
  .div1 {
    .warning-img {
      width: 1.5rem;
    }
    .warning-txt {
      margin-left: 0.3rem;
      font-size: 1.2rem;
      font-weight: 600;
      color: #f14950;
    }
  }
  .div2 {
    margin-top: 1rem;
    text-align: center;
    .txt {
      font-size: 0.8rem;
      line-height: 1.5rem;
      font-weight: 600;
      color: #555;
    }
  }
  
}

.notice-block {
  padding: 0 0.5rem;
  .notice-txt {
    color: #555;
    margin: 1.7rem 0 0.8rem 0;
    display: inline-block;
    font-size: 1.1rem;
    font-weight: 600;
  }
  .notice-txt2 {
    font-size: 0.8rem;
    color: #0a0a0a;
    line-height: 1.8rem;
    color: #555;
  }
}

.info-block {
  padding: 0 0.6rem 0 0.6rem;
  div {
    margin-bottom: 1rem;
  }
  input {
    width: 100%;
    color: #666;
    padding: 0.4rem 0.5rem;
    font-size: 0.95rem;
    line-height: 1.5rem;
    outline: none;
    border-color: rgb(169, 215, 247);
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  input:focus {
    border-color: rgb(33, 164, 252);
  }
  textarea {
    width: 100%;
    height: 7rem;
    outline: none;
    resize: none;
    font-size: 1rem;
    padding: 0.3rem 0.5rem;
    line-height: 1.5rem;
    border-radius: 0.25rem;
    color: #666;
    border-color: rgb(169, 215, 247);
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  textarea:focus {
    border-color: rgb(33, 164, 252);
  }
}

.btn {
  width: 100%;
  height: 2.4rem;
  color: white;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.1rem;
  border-top-left-radius: 1.25rem;
  border-bottom-left-radius: 1.25rem;
  border-top-right-radius: 1.25rem;
  border-bottom-right-radius: 1.25rem;
  background-color: #5ebfd2;
  margin-top: 0.6rem;
  margin-bottom: 3.5rem;
}
.state-tip {
  display: inline-block;
  padding: 0 0 6rem 0;
  font-size: 0.85rem;
  color: #333;
  margin-left: 0.6rem;
}
</style>